var $ = require('jquery');

export class MainNavigation {
  private jsBlock: string;
  private block: string;
  private $el;
  private $dropdownLinks;
  private $dropdownLis;
  private liHoverClass;
  private $activeParent;

  constructor(selector) {
    this.block = selector;
    this.jsBlock = 'js-' + selector;

    this.$el = $('#' + this.jsBlock);

  }

  private _initListeners () {
    var self = this;

    this.liHoverClass = this.block + '__li--hover';
    this.$dropdownLis = this.$el.find('.' + this.block + '__level--0 > .' + this.block + '__li--has-children');
    this.$dropdownLinks = this.$el.find('.' + this.block + '__level--0 > .' + this.block + '__li--has-children > .' + this.block + '__link');

    this.$dropdownLinks.on('click', function(e) {
      var $this = $(this),
          $parentLi = $this.parent('.' + self.block + '__li');

      e.preventDefault();

      // If active link is found, remove hover class
      if (self.$activeParent && self.$activeParent.length) {
        self.$activeParent.removeClass(self.liHoverClass);
      }


      if($parentLi.is(self.$activeParent)) {
        $parentLi.removeClass(self.liHoverClass);
        self.$activeParent = null;
      } else {
        $parentLi.addClass(self.liHoverClass);
        self.$activeParent = $parentLi;
      }

    });
  }

  public init () {
    if(!this.$el.length) {
      return;
    }

    this._initListeners();
  }

  public closeDropdowns() {
    this.$dropdownLis.removeClass(this.liHoverClass);
    this.$activeParent = null;
  }
}
